var $130ce4093fe216d5$exports = {};
$130ce4093fe216d5$exports = {
    "help": `Ajutor`,
    "info": `Informa\u{163}ii`
};


export {$130ce4093fe216d5$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
